import { ChangeDetectionStrategy, Component } from '@angular/core';

import { AuthService } from '@auth/services';
import { CustomerService } from '@customer/services';

@Component({
  selector: 'z-user-customer',
  templateUrl: './user-customer.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UserCustomerComponent {
  constructor(public authService: AuthService, public customerService: CustomerService) {}
}
